import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';
import { DSIcon } from '@spotahome/ui-library/base';
import { OPEN_GUARANTEE_MODAL } from '@spotahome/ui-library/src/tenant/components/utils/constants';

import LandlordLivesInHouseModal from './LandlordLivesInHouseModal';
import PetsAllowedModal from './PetsAllowedModal';

import '../PropertyRulesRedesign.scss';

const ModalTitle = ({ name, icon }) => (
  <span className="property-rules-redesign__modal-title">
    <DSIcon name={icon} /> {name}
  </span>
);

const genericModal = {
  showModal: rule => !!rule?.additionalInfo,
  onClick:
    (rule, { name, icon }) =>
    () => {
      Mediator.publish(OPEN_GUARANTEE_MODAL, {
        title: <ModalTitle name={name} icon={icon} />,
        body: <div>{rule?.additionalInfo}</div>
      });
    }
};

export const MODAL_RULES_CONFIGURATION = {
  landlordLivesInHouse: {
    showModal: rule => rule?.landlordBirthday || rule?.landlordGender,
    onClick:
      (rule, { icon }) =>
      () => {
        Mediator.publish(OPEN_GUARANTEE_MODAL, {
          title: (
            <ModalTitle
              name={trans('listing.landlord_info.title')}
              icon={icon}
            />
          ),
          body: <LandlordLivesInHouseModal rule={rule} />
        });
      }
  },
  petsAllowed: {
    showModal: rule =>
      rule?.allowedTypes || rule?.price || rule?.additionalInfo,
    onClick:
      (rule, { currency, name, icon }) =>
      () => {
        Mediator.publish(OPEN_GUARANTEE_MODAL, {
          title: <ModalTitle name={name} icon={icon} />,
          body: <PetsAllowedModal rule={rule} currency={currency} />
        });
      }
  },
  domiciliationAllowed: genericModal,
  newContractValidForScholarship: genericModal
};

export default { MODAL_RULES_CONFIGURATION };
